import { render, staticRenderFns } from "./VPaginationBar.vue?vue&type=template&id=0a7c3094&scoped=true&"
import script from "./VPaginationBar.vue?vue&type=script&lang=ts&"
export * from "./VPaginationBar.vue?vue&type=script&lang=ts&"
import style0 from "./VPaginationBar.vue?vue&type=style&index=0&id=0a7c3094&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7c3094",
  null
  
)

export default component.exports